export const isSingleDate = (dateString) => {
  return dateString.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
}

export const isDateRange = (dateString) => {
  return dateString.match(/^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2})\/(\d{2})\/(\d{4})$/)
}

const isValidDate = (day, month, year) => {
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === parseInt(year, 10) &&
    date.getMonth() === parseInt(month, 10) - 1 &&
    date.getDate() === parseInt(day, 10)
  );
};

export const isValidDateOrRangeFormat = (dateString) => {
  const singleMatch = isSingleDate(dateString)
  if (singleMatch) {
    const [_, day, month, year] = singleMatch
    return isValidDate(day, month, year);
  }

  const rangeMatch = isDateRange(dateString)
  if (rangeMatch) {
    const [_, startDay, startMonth, startYear, endDay, endMonth, endYear] = rangeMatch
    return isValidDate(startDay, startMonth, startYear) && isValidDate(endDay, endMonth, endYear)
  }

  return false
}

export const getMilliseconds = (dateString) => {
  if (!dateString) {
    return
  }

  const [day, month, year] = dateString.split("/")
  return new Date(year, month - 1, day).getTime()
}

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export const formatIsoToDisplay = (isoDate) => {
  const date = new Date(isoDate + "T00:00:00")
  return `${DAY_NAMES[date.getDay()]} ${date.getDate()} ${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`
}

export const formatIsoToForm = (isoDate) => {
  const [year, month, day] = isoDate.split("-")
  return `${day}/${month}/${year}`
}

export const parseFormDateToIso = (dateStr) => {
  const [day, month, year] = dateStr.trim().split("/")
  return `${year}-${month}-${day}`
}
